module.exports = __webpack_public_path__ + "img/questions.f0294f14.png";